import { render, staticRenderFns } from "./DialogAddLecture.vue?vue&type=template&id=32b4da9a&"
import script from "./DialogAddLecture.vue?vue&type=script&lang=js&"
export * from "./DialogAddLecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports